import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CorteService } from 'src/app/services/corte.service';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';

@Component({
  selector: 'app-formato-retiro',
  templateUrl: './formato-retiro.component.html',
  styleUrls: ['./formato-retiro.component.scss']
})
export class FormatoRetiroComponent implements OnInit {

  retiros: any[];
  data$: Observable<FormatoData>;
  finalise = new Subject();

  constructor(
    private formatoService: FormatoService,
    private toastr: ToastrService,
    private corteService: CorteService
  ) {
    this.data$ = formatoService.obtenerData;
  }

  ngOnInit(): void {


    this.data$.pipe(takeUntil(this.finalise)).subscribe( data => {
      if ( data.tipo === 4 ) {
        this.corteService.getCorteRetiros( data.id_corte_usuario ).subscribe( retiros => {
          this.retiros = retiros;
          console.log( this.retiros );
        });
      }
      this.finalise.next();
      this.finalise.complete();
    });

  }

}
